<template>
    <div
        v-if="tabs && tabs.length > 0"
        class="new-relevant-rank-list-wrapper pb-show-display"
        :data-pblog="pblog"
    >
        <div class="title-wrapper">
            <div class="left">
                <span class="top">{{ gameInfo.game_name }}相关榜单</span>
                <span class="bottom">{{ role }}</span>
            </div>
            <div class="right" @click="goList('lotteryBtnClick')">
                <span class="text">打榜抽盲盒</span>
                <img src="https://fenwan.cdn.bcebos.com/cms/gamenow/webgame/2023-2/1675668674954/3a807ec19220.gif" class="box-ani">
                <img :src="moreIcon" class="more-icon">
            </div>
        </div>
        <div class="tab-wrapper">
            <div
                v-for="(tabItem, index) in tabs"
                :key="index"
                class="tab-item"
                :class="{'tab-item-active': index === curTabIndex}"
                @click="onTabClick(index, tabItem.tab_id, tabItem.tab_name, tabItem.tag_id, tabItem.tag_name)"
            >
                <span class="tab-name">{{ tabItem.rank_name }}</span>
            </div>
        </div>
        <div class="game-list-wrapper">
            <div
                v-for="(gameItem, gameIndex) in gameList"
                :key="curTabId + gameItem.game_id"
            >
                <game-card
                    :page-game-info="gameInfo"
                    :game-info="gameItem"
                    :fire-btn-action="fireBtnAction"
                    :game-index="gameIndex"
                    :cur-tab-id="curTabId"
                    :cur-tag-id="curTagId"
                    :cur-tab-name="curTabName"
                    :cur-tag-name="curTagName"
                    :tieba-info="tiebaInfo"
                />
            </div>
        </div>
        <div class="more-btn" @click="goList('moreClick')">
            <span>查看更多</span>
            <img :src="moreIcon" class="more-icon">
        </div>
    </div>
</template>

<script>
import {getQueryString} from '@/utils/url';
import moreIcon from 'public/assets/imgs/ic_more_grey.png';
import GameCard from './app-detail-game-card.vue';
import api from '@/api';

export default {
    components: {
        GameCard,
    },
    data() {
        return {
            moreIcon: moreIcon,
            role: '',
            titleOpenAction: 0,
            fireBtnAction: 0,
            tabs: [],
            gameList: [],
            gameInfo: {},
            gameOpenAction: 0,
            curTabId: 0,
            curTabName: '',
            curTagId: '',
            curTagName: '',
            curTabIndex: 0,
            tiebaInfo: {},
        };
    },
    computed: {
        // 模块展现参数
        baseLog() {
            const {game_name, game_id, game_type} = this.gameInfo;
            return {
                pageGameName: game_name,
                pageGameId: game_id,
                pageGameType: game_type || '',
                module: 'recommendedModule',
                sid: getQueryString('sid') || '',
                srcId: getQueryString('srcid') || '',
                channelid: getQueryString('channelid') || '',
            };
        },
        pblog() {
            return JSON.stringify({
                value: 'recommendedModuleDisplay',
                ext: {
                    item: [
                        {
                            id: '',
                            ext: this.baseLog,
                            pos: '',
                        },
                    ],
                },
            });
        },
        tabsName() {
            const tabName = [];
            this.tabs.forEach(item => {
                tabName.push(item.rank_name);
            });
            return tabName;
        },
    },
    watch: {
    },
    mounted() {
        this.getReleVantData();
    },
    methods: {
        // 获取相关榜单tab
        getReleVantData() {
            api.zone.getReleVantRankTabs({
                game_id: getQueryString('appId'),
            }).then(res => {
                this.gameInfo = res.game_info;
                this.tabs = res.rank_list || [];
                this.role = res.rank_role || '';
                this.titleOpenAction = res.open_btn_action;
                this.fireBtnAction = res.fire_btn_action;
                this.tiebaInfo = res.tieba_info;
                if (this.tabs.length > 0) {
                    this.curTabId = this.tabs[0].tab_id;
                    this.curTagId = this.tabs[0].tag_id;
                    this.getGameList();
                }
            });
        },
        getGameList() {
            api.zone.getReleVantRankList({
                tab_id: this.curTabId,
                tag_id: decodeURIComponent(this.curTagId),
                page_num: 1,
                page_size: 4,
            }).then(data => {
                this.gameList = data.game_list || [];
                this.gameOpenAction = data.open_btn_action;
            });
        },

        // 前往热力榜页面
        goList(type) {
            const origin = window.location.origin;
            const gameId = this.gameInfo.game_id;
            this.$root.sendLog('click', type, {
                ...this.baseLog,
                primaryTab: this.curTabId,
                secondaryTab: this.curTagId,
            });
            const url = `${origin}/static/game/tb-list-activity.html?game_id=${gameId}`;
            // 贴吧内直接进入热力榜页面
            if (this.$root.isTiebaApp || type === 'relevant-rank-bottom-more-click') {
                setTimeout(() => {
                    window.location.href = url;
                }, 100);
            }
            else {
                const token = this.$root.getToken(url);
                this.$root.report(token).then(() => {
                    if (+this.titleOpenAction === 2) { // 调起贴吧
                        this.$root.wakeUpTiebaApp(token, url, this.tiebaInfo.android_smart_download_url);
                    }
                    else { // 进入下载中间页
                        window.location.href = this.$root.middlePage;
                    }
                });
            }
        },
        // tab点击
        onTabClick(index, tabId, tabName, tagId, tagName) {
            if (this.curTabIndex === index) {
                return;
            }
            this.curTabIndex = index;
            this.curTabId = tabId;
            this.curTabName = tabName;
            this.curTagId = tagId;
            this.curTagName = tagName;
            this.$root.sendLog('click', 'tabClick', {
                ...this.baseLog,
                postTab: tabId,
                postTag: tagId,
            });
            this.getGameList();
        },
    },
};
</script>

<style lang="scss">
.new-relevant-rank-list-wrapper {
    width: 100%;
    margin-top: 120px;
    box-sizing: border-box;
    padding: 0 51px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title-wrapper {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 120px;

        .left {
            display: flex;
            flex-direction: column;

            .top {
                max-width: 800px;
                font-family: PingFangSC-Medium;
                font-size: 57px;
                color: #1F1F1F;
                line-height: 57px;
                font-weight: 500;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }

            .bottom {
                max-width: 800px;
                font-size: 42px;
                color: #8F8E94;
                margin-top: 21px;
                line-height: 42px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        .right {
            display: flex;
            align-items: center;
            flex-shrink: 0;

            .text {
                font-size: 36px;
                color: #8F8E94;
                max-width: 200px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsiszh;
            }

            .box-ani {
                margin-left: 6px;
                width: 90px;
                height: 90px;
            }

            .more-icon {
                width: 25px;
                height: 40px;
                margin-left: 12px;
            }
        }
    }

    .tab-wrapper {
        width: 1140px;
        height: 108px;
        background-color: #f8f8f8;
        display: flex;
        margin-top: 60px;
        align-items: center;
        padding: 0 6px;
        box-sizing: border-box;
        border-radius: 24px;

        .tab-item {
            width: 376px;
            height: 96px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 42px;
            color: #1f1f1f;

            .tab-name {
                max-width: 360px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        .tab-item-active {
            background-color: #fff;
            border-radius: 22px;
            color: #38f;
        }
    }

    .game-list-wrapper {
        width: 1140px;
    }

    .more-btn {
        margin-top: 4px;
        display: flex;
        justify-content: center;
        font-size: 48px;
        color: #858585;
        line-height: 48px;
        align-items: center;

        .more-icon {
            width: 25px;
            height: 40px;
            margin-left: 18px;
            margin-top: 3px;
        }
    }
}
</style>